import axios from 'axios';
import type { SiteId } from '@hotjar/site';
import type { FeedbackSummary } from './types';
import type { FeedbackWidgetsResponse } from './dto';
import { mapFeedbackSummaryResponseDtoToModel } from './mapper';

export async function getFeedbackSummary(
  siteId: SiteId,
  shouldUseSeparateAskService: boolean,
): Promise<FeedbackSummary> {
  const separateAskServicePrefix = shouldUseSeparateAskService ? 'ask/' : '';
  const response: FeedbackWidgetsResponse = await axios.get(
    `/api/${separateAskServicePrefix}v1/sites/${siteId}/dashboard/feedback-widgets`,
  );
  return mapFeedbackSummaryResponseDtoToModel(response.data);
}
